import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import api from '../services/CustomerApiNew';



const API_BASE_URL = '/api/v1';


function ServiceListingPage() {

	const { serviceType, city } = useParams();

	const [providers, setProviders] = useState([]);
	
	const toPascalCase = (str) => {
	    if (!str) return '';
	    return str
	        .split(/[\s_-]+/) // Handles spaces, hyphens, and underscores
	        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
	        .join('');
	};

	useEffect(() => {

		const loadProviders = async () => {

			try {

				const response = await api.get(
					`${API_BASE_URL}/providers/search`,
					{
						params: {
							serviceType: toPascalCase(serviceType),
							city,
							isFullData: false
						}
					}
				);

				setProviders(response.data);

			} catch (err) {

				console.error(err);

			}

		};

		loadProviders();

	}, [serviceType, city]);

	return (
		<>

			<Helmet>
				<title>
					{toPascalCase(serviceType)} in {city} | MyBharatService
				</title>

				<meta
					name="description"
					content={`Find trusted ${serviceType} in ${city} and connect directly on WhatsApp.`}
				/>

				<link
					rel="canonical"
					href={`https://mybharatservice.com/service/${serviceType}/${city}`}
				/>
			</Helmet>

			<div>

				<h1>
					{toPascalCase(serviceType)} in {city}
				</h1>
				
				

				<p>Find trusted {serviceType} in {city} and connect directly on WhatsApp.</p>

				{providers.map(provider => (
					<div key={provider.providerId}>
						<h3>{provider.name}</h3>
						<p>{provider.city}</p>
					</div>
				))}
				
				<p>
				Looking for experienced {serviceType} in {city}?
				Browse verified {serviceType}  and connect directly through WhatsApp.
				</p>

				<h2>Why Choose MyBharatService?</h2>

				<ul>
				  <li>Direct WhatsApp connection</li>
				  <li>No middlemen</li>
				  <li>Verified professionals</li>
				</ul>

			</div>
		</>
	);
}

export default ServiceListingPage;